import React, { useState, useEffect } from 'react';
import { getWebhookByUser, savewebhook, deletewebhook } from '../components/DbServices';
import { getStoredUser } from '../utilities/encryption';
import Layout from '../layout/Layout';
import PageTransition from '../components/PageTransition';
import Swal from 'sweetalert2';

// const SUPPORTED_APPS = [
//     { id: 'zapier', name: 'Zapier', category: 'Automation', logo: 'https://1000logos.net/wp-content/uploads/2022/09/Zapier-Logo-1536x864.png' },
//     { id: 'make', name: 'Make.com', category: 'Automation', logo: 'https://cdn.brandfetch.io/idVHU5hl7_/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', color: '#6d28d9' },
//     { id: 'pabbly', name: 'Pabbly', category: 'Automation', logo: 'https://cdn.brandfetch.io/idcmVVrrBQ/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', color: '#00a1ff' },
//     { id: 'zoho', name: 'Zoho Flow', category: 'CRM', logo: 'https://www.vectorlogo.zone/logos/zoho/zoho-icon.svg', color: '#e31d1d' },
//     { id: 'hubspot', name: 'HubSpot', category: 'CRM', logo: 'https://www.vectorlogo.zone/logos/hubspot/hubspot-icon.svg', color: '#ff7a59' },
//     { id: 'slack', name: 'Slack', category: 'Chat', logo: 'https://www.vectorlogo.zone/logos/slack/slack-icon.svg', color: '#4a154b' },
//     { id: 'google_sheets', name: 'Google Sheets', category: 'Data', logo: 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', color: '#0f9d58' },
//     { id: 'custom', name: 'Webhook', category: 'Dev', logo: null, icon: 'bi bi-code-slash', color: '#334155' }
//   ];


const SUPPORTED_APPS = [
    // POPULAR AUTOMATION
    { id: 'zapier', name: 'Zapier', category: 'Automation', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/zapier.svg', color: '#ff4f00' },
    { id: 'make', name: 'Make.com', category: 'Automation', logo: 'https://cdn.brandfetch.io/idVHU5hl7_/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', color: '#6d28d9' },
    { id: 'pabbly', name: 'Pabbly', category: 'Automation', logo: 'https://cdn.brandfetch.io/idcmVVrrBQ/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', color: '#00a1ff' },
  
    // CRM & SALES
    { id: 'zoho', name: 'Zoho Flow', category: 'CRM', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/zoho.svg', color: '#e31d1d' },
    { id: 'hubspot', name: 'HubSpot', category: 'CRM', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/hubspot.svg', color: '#ff7a59' },
    { id: 'salesforce', name: 'Salesforce', category: 'CRM', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/salesforce.svg', color: '#00a1e0' },
  
    // E-COMMERCE
    { id: 'shopify', name: 'Shopify', category: 'Shop', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/shopify.svg', color: '#96bf48' },
    { id: 'woocommerce', name: 'WooCommerce', category: 'Shop', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/woocommerce.svg', color: '#96588a' },
  
    // CHAT & TEAMS
    { id: 'slack', name: 'Slack', category: 'Chat', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/slack.svg', color: '#4a154b' },
    { id: 'discord', name: 'Discord', category: 'Chat', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/discord.svg', color: '#5865f2' },
    { id: 'telegram', name: 'Telegram', category: 'Chat', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/telegram.svg', color: '#0088cc' },
  
    // DATA & SHEETS
    { id: 'google_sheets', name: 'Google Sheets', category: 'Data', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/googlesheets.svg', color: '#0f9d58' },
    { id: 'airtable', name: 'Airtable', category: 'Data', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/airtable.svg', color: '#18bfff' },
  
    // EMAIL MARKETING
    { id: 'mailchimp', name: 'Mailchimp', category: 'Email', logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/mailchimp.svg', color: '#FFE01B' },
    
    // CUSTOM
    { id: 'custom', name: 'Custom Webhook', category: 'Dev', logo: null, icon: 'bi bi-code-slash', color: '#334155' }
  ];

export default function Integrations() {
  const user = getStoredUser();
  const userId = user?.data?.id;

  const [activeHooks, setActiveHooks] = useState({});
  const [selectedApp, setSelectedApp] = useState(null);
  const [webhookUrl, setWebhookUrl] = useState('');
  const [filter, setFilter] = useState('All');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userId) fetchActive();
  }, [userId]);

  const fetchActive = async () => {
    try {
      const res = await getWebhookByUser(userId);
      if (res?.status === 200 && Array.isArray(res.data)) {
        const hooksMap = {};
        
        res.data.forEach(h => {
          const url = h.webhook_url.toLowerCase();
  
          // 1. If the API provides the key, use it (Best case)
          if (h.app_key) {
            hooksMap[h.app_key] = h;
          } 
          // 2. Identify by URL content
          else if (url.includes('google.com') || url.includes('sheets')) {
            hooksMap['google_sheets'] = h;
          } else if (url.includes('zapier.com')) {
            hooksMap['zapier'] = h;
          } else if (url.includes('make.com') || url.includes('integromat')) {
            hooksMap['make'] = h;
          } else if (url.includes('pabbly.com')) {
            hooksMap['pabbly'] = h;
          } else if (url.includes('zoho.com')) {
            hooksMap['zoho'] = h;
          } 
          else if (url.includes('woocommerce') || url.includes('wc-api') || url.includes('wp-json')) {
            hooksMap['woocommerce'] = h;
          }
          // 3. If it's none of the above, map it to 'custom' 
          // (This explains why your 'test.com' wasn't showing up)
          else {
            hooksMap['custom'] = h;
          }
        });
        
        setActiveHooks(hooksMap);
      }
    } catch (err) {
      console.error("Failed to fetch webhooks", err);
    }
  };
  const handleConnect = async () => {
    if (!webhookUrl.startsWith('http')) {
      return Swal.fire("Invalid URL", "Please enter a valid URL starting with http/https", "error");
    }

    try {
      setLoading(true);
      const res = await savewebhook({
        user_id: userId,
        app_key: selectedApp.id,
        webhook_url: webhookUrl
      });

      if (res.status === 200) {
        Swal.fire({
          title: "Connected!",
          text: `${selectedApp.name} integration is now active.`,
          icon: "success",
          confirmButtonColor: '#4f46e5'
        });
        setSelectedApp(null);
        setWebhookUrl('');
        fetchActive();
      }
    } catch (err) {
      Swal.fire("Error", "Failed to save integration", "error");
    } finally {
      setLoading(false);
    }
  };

  const filteredApps = filter === 'All' ? SUPPORTED_APPS : SUPPORTED_APPS.filter(a => a.category === filter);

  return (
    <Layout>
      <PageTransition>
        <div className="container-fluid py-4">
          
          {/* HEADER SECTION */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1"><span className="color-theme">App Marketplace</span> 🧩</h3>
              <p className="text-muted small fw-medium">Bridge your WhatsApp events with 5,000+ third-party tools.</p>
            </div>
            
            <div className="d-flex gap-1 bg-white p-1 rounded-pill shadow-sm border">
              {['All', 'Automation', 'CRM', 'Chat', 'Data'].map(cat => (
                <button 
                  key={cat} 
                  onClick={() => setFilter(cat)} 
                  className={`btn btn-sm rounded-pill px-3 fw-bold border-0 transition-all ${filter === cat ? 'btn-primary shadow-sm' : 'text-muted hover-light'}`}
                  style={filter === cat ? { background: 'linear-gradient(45deg, #4f46e5, #9333ea)' } : {}}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* GRID DATA */}
          <div className="row g-4">
            {filteredApps.map(app => {
              const isActive = !!activeHooks[app.id];
              return (
                <div key={app.id} className="col-md-6 col-lg-4 col-xl-3">
                  <div className={`card border-0 shadow-sm rounded-4 h-100 transition-all hover-lift ${isActive ? 'bg-white' : 'bg-white opacity-90'}`}>
                    <div className="card-body p-4 text-center d-flex flex-column">
                      
                      {/* Badge for Active State */}
                      <div className="d-flex justify-content-end mb-2" style={{ height: '20px' }}>
                        {isActive && (
                          <span className="badge rounded-pill bg-success-subtle text-success fw-bold" style={{ fontSize: '9px' }}>
                            <i className="bi bi-patch-check-fill me-1"></i> ACTIVE
                          </span>
                        )}
                      </div>

                      <div className="mb-4 d-flex align-items-center justify-content-center" style={{ height: '60px' }}>
                        {app.logo ? (
                          <img 
                            src={app.logo} 
                            alt={app.name} 
                            style={{ maxHeight: '45px', maxWidth: '140px', filter: isActive ? 'none' : 'grayscale(1) opacity(0.6)' }} 
                          />
                        ) : (
                          <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                            <i className={`${app.icon} fs-2 text-secondary`}></i>
                          </div>
                        )}
                      </div>

                      <h6 className="fw-bold text-dark mb-1">{app.name}</h6>
                      <p className="text-uppercase text-muted fw-bold mb-4" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>{app.category}</p>

                      <button 
                        onClick={() => { setSelectedApp(app); setWebhookUrl(activeHooks[app.id]?.webhook_url || ''); }}
                        className={`btn btn-sm w-100 rounded-pill fw-bold mt-auto py-2 border-0 shadow-sm transition-all ${isActive ? 'btn-light text-primary' : 'btn-primary'}`}
                       
                      >
                        {isActive ? 'CONFIGURE' : 'CONNECT'}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </PageTransition>

      {/* CONNECTION MODAL */}
      {selectedApp && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(15, 23, 42, 0.7)', backdropFilter: 'blur(4px)', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
              
              <div className="p-4 text-white d-flex align-items-center justify-content-between" style={{ background: 'linear-gradient(45deg, #4f46e5, #9333ea)' }}>
                <h5 className="fw-bold mb-0">Connect {selectedApp.name}</h5>
                <button onClick={() => setSelectedApp(null)} className="btn-close btn-close-white shadow-none"></button>
              </div>

              <div className="modal-body p-4">
                <p className="text-muted small mb-4">
                  Paste the <b>Webhook URL</b> provided by {selectedApp.name} to receive real-time events from your WhatsApp instances.
                </p>

                <div className="mb-3">
                  <label className="form-label small fw-bold text-muted text-uppercase tracking-wider">Target Endpoint URL</label>
                  <div className="input-group mb-2">
                    <span className="input-group-text bg-light border-0"><i className="bi bi-link-45deg"></i></span>
                    <input 
                      type="url" 
                      className="form-control bg-light border-0 py-2 shadow-none fw-medium" 
                      placeholder="https://hooks.dialogix.com/..." 
                      value={webhookUrl} 
                      onChange={(e) => setWebhookUrl(e.target.value)}
                    />
                  </div>
                  <div className="form-text" style={{ fontSize: '11px' }}>
                    <i className="bi bi-info-circle me-1"></i> Use "Catch Hook" trigger in {selectedApp.name}.
                  </div>
                </div>

                <div className="bg-light p-3 rounded-3 mb-4">
                    <h6 className="small fw-bold mb-2">Instructions:</h6>
                    <ol className="small text-muted ps-3 mb-0">
                        <li>Log in to your {selectedApp.name} account.</li>
                        <li>Create a new workflow and select "Webhook" as trigger.</li>
                        <li>Copy the URL provided and paste it here.</li>
                    </ol>
                </div>

                <button 
                  className="btn btn-primary w-100 py-2 rounded-pill fw-bold border-0 shadow" 
                  style={{ background: 'linear-gradient(45deg, #4f46e5, #9333ea)' }}
                  onClick={handleConnect}
                  disabled={loading}
                >
                  {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : <i className="bi bi-plug-fill me-2"></i>}
                  ENABLE INTEGRATION
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .hover-lift:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important; }
        .bg-success-subtle { background-color: #dcfce7 !important; }
        .text-success { color: #166534 !important; }
        .tracking-wider { letter-spacing: 0.05rem; }
        .hover-light:hover { background-color: #f1f5f9; }
      `}</style>
    </Layout>
  );
}